/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * TeacherBase
 * auto generated base class for the model TeacherModel.
 */
export const TeacherModelBase = ModelBase.named('Teacher')
  .props({
    __typename: types.optional(types.literal('Teacher'), 'Teacher'),
    image: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
    role: types.union(types.undefined, types.string),
    statement: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TeacherModelSelector extends QueryBuilder {
  get image() {
    return this.__attr('image')
  }
  get name() {
    return this.__attr('name')
  }
  get role() {
    return this.__attr('role')
  }
  get statement() {
    return this.__attr('statement')
  }
}
export function selectFromTeacher() {
  return new TeacherModelSelector()
}

export const teacherModelPrimitives = selectFromTeacher().image.name.role.statement
